import React, { useEffect }  from 'react';

export default (props) => {
       

    
    useEffect(() => {
       
    }, []);

    const drawDetails = (details) => {
        
        let res = [];
        
        Object.keys(details.data).forEach( annex => {
            
            const annex_entries = details.data[annex];
                       
            annex_entries.forEach( entry => {
                         
                let max_concentration   = entry.max_concentration_use_preparation || entry.max_concentration_in_ready_for_use || null;                                            
                let wordings            = entry.wording_conditions_use_warnings  || entry.wording_of_conditions_of_use_and_warning || null;
                const is_annex_ii       = annex.substr(0,3) === "ii/";
                let content             = [];
                const formatted_annex   = annex.split("/")[0].toUpperCase() + "/" +annex.split("/")[1]
                        
               
           
                if(is_annex_ii){
                                                           
                    content.push(<table>
                            <tr>
                                <th>Annexe / N° d'ordre</th>                                                                                  
                            </tr>
                            <tr>
                            <td><span style={{color:"red"}}><b>{formatted_annex}</b></span></td>   
                            </tr>
                        </table>); 
                
                    content.push(<table class="table-details"> 
                            <tr>
                                <th class="th-inci">Nom INCI / Nom Chimique</th>                              
                                <th>N° CAS</th>
                                <th>N° CE</th>
                            </tr>

                            <tr>
                                <td>
                                    <span style={{color:"red"}}> {entry.chemical_name_inn}</span>                                
                                </td>                               
                                <td>{entry.cas}</td>
                                <td>{entry.ec}</td> 
                            </tr>
                        </table>);
                }
                else{
                    
                    content.push(<table>
                            <tr>
                                <th>Annexe / N° d'ordre</th>                                                                                  
                            </tr>
                            <tr>
                                <td><b>{annex.toUpperCase()}</b></td>   
                            </tr>
                            </table>);
                    
                    content.push(<table class="table-details"> 
                            <tr>
                                <th class="th-inci">Nom INCI / Nom Chimique</th>                              
                                <th>N° CAS</th>
                                <th>N° CE</th>
                            </tr>

                            <tr>
                                <td>                                    
                                    <span>{entry.chemical_name_inn}</span>                                                                     
                                </td>                               
                                <td>{entry.cas}</td>
                                <td>{entry.ec}</td> 
                            </tr>
                        </table>);
                
                    content.push(<table>
                            <tr>
                                <th>Types de produit, parties du corps</th>                                                                                  
                            </tr>
                            <tr>
                                <td class="pre-warp">{entry.product_type_body_parts || ""}</td>   
                            </tr>

                            <tr>
                                <th>Concentration maximale dans les préparations prêtes à l'emploi</th>                                                                                  
                            </tr>
                            <tr>
                               <td class="pre-warp">{max_concentration}</td>  
                            </tr>

                            <tr>
                                <th>Autres restrictions / Conditions</th>                                                                                  
                            </tr>
                            <tr>
                                <td class="pre-warp">{entry.other || ""}</td>   
                            </tr>

                            <tr>
                                <th>Libellé des conditions d’emploi et des avertissements à reprendre sur l’étiquetage</th>                                                                                  
                            </tr>
                            <tr>
                                <td class="pre-warp">{wordings}</td>   
                            </tr>
                        </table>);          
                }
                
                res.push(
                    <div class="container-details">                            
                         {content}         
                    </div>
                );

            });
        });
        
            return res.length === 0 ? <div class="container-details no-entry">Aucune entrée annexe</div> : res;
    };
    return (

        <div>
        {
            drawDetails(props.details)
        }
        </div>
    );
}

